export default "__VITE_ASSET__DDu2ZGo9__"